import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { BrMgmtNavigationWrapperWC } from '@juliusbaer-gcrm/pcm-br-mgmt-components/BrMgmtNavigationWrapperWC';
import { BrTabItems } from 'views/BrTabs/BrTabs';
import { ProfilingSection } from 'views/BrTabs/components/ProfilingSections/ProfilingSection';
import { useRuntimeConfig } from 'config/useRuntimeConfig';
import { NavigationWizardSectionRenderParams } from 'views/BrTabs/types/navigationWizardMode';

export function CoreDataSection({ selectedTab, navigateToTab }: NavigationWizardSectionRenderParams): ReactNode {
  const runtimeConfig = useRuntimeConfig();
  const { t } = useTranslation();
  const isActive = selectedTab === BrTabItems.CORE_DATA;

  return ProfilingSection({
    tabId: BrTabItems.CORE_DATA,
    title: t('navigationWizard.item.title.brCoreData'),
    isActive,
    isProfilingRelevant: false,
    onSectionSelect: () => navigateToTab(BrTabItems.CORE_DATA),
    children: (
      <BrMgmtNavigationWrapperWC
        env={runtimeConfig.envInfo.envId}
        version="0.0.1"
        onSectionSelect={() => navigateToTab(BrTabItems.CORE_DATA)}
        isActive={isActive}
      />
    ),
  });
}
